import * as React from 'react';
import { ArticleHeading2, UIText1 } from '@cian/ui-kit/typography';
import { ConditionalWrapper } from '@cian/conditional-component';
import { useIsDesktop } from '@cian/valuation-utils-component';

import { RealtorCard } from './components/RealtorCard/RealtorCard';
import { CardAvatarContainer } from '../../containers/CardAvatarContainer';
import { ISpecialistCatalogListing } from '../../types/demand/specialistListing';
import { BigTitle } from '../BigTitle';

import * as styles from './styles.css';

export interface IQuizCompletedProps {
  backToPage: React.ReactElement;
  realtors: ISpecialistCatalogListing[];
  title: string;
  subtitle: string;
  description?: string;
  footer?: React.ReactElement;
}

export const QuizPersonalApplication: React.FC<React.PropsWithChildren<IQuizCompletedProps>> = props => {
  const { backToPage, title, subtitle, description, footer, realtors } = props;
  const isDesktop = useIsDesktop();

  return (
    <div className={styles['wrapper']} data-testid="success">
      {isDesktop && <div className={styles['header']}>{backToPage}</div>}
      <div className={styles['container']}>
        <div className={styles['title']}>
          <ConditionalWrapper if={isDesktop} ThenComponent={BigTitle} ElseComponent={ArticleHeading2}>
            {title}
          </ConditionalWrapper>
        </div>
        <div className={styles['text']}>
          <UIText1 color="current_color">{subtitle}</UIText1>
        </div>
        {description && (
          <div className={styles['description']}>
            <UIText1 color="current_color">{description}</UIText1>
          </div>
        )}
        <div className={styles['cards']}>
          {realtors.map(({ fullName, id, timeOnSite, agencyName, avatarUrl, qualityLevel }) => (
            <RealtorCard
              key={id}
              previewImg={<CardAvatarContainer imgUrl={avatarUrl} fullName={fullName} isCircleImage={true} />}
              name={fullName}
              isSuperAgentStarShown={qualityLevel === 4}
              timeOnSite={timeOnSite}
              agencyName={agencyName}
            />
          ))}
        </div>
        {footer && (
          <div className={styles['footer']} data-testid="footer">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

QuizPersonalApplication.displayName = 'QuizPersonalApplication';
